import React, { useMemo } from "react";
import {
  buildWeekDays,
  formatWeekdayShort,
  groupEventsByDay,
  isSameDay,
  startOfDayLocal,
} from "./calendarGrid";
import EventosAgrupados from "./EventosAgrupados";
import { consultaDeFeriado } from "./feriados";
import {
  DayNumber,
  EmptyMessage,
  FeriadoChip,
  WeekColumn,
  WeekColumnBody,
  WeekColumnHeader,
  WeekGrid,
  WeekWeekdayLabel,
} from "./styles";

export default function WeekView({
  feriadoDe = consultaDeFeriado(),
  cursor,
  events,
  weekStartsOn,
  onSelectEvent,
  onJumpToDay,
  emptyMessage,
}) {
  const today = useMemo(() => startOfDayLocal(new Date()), []);
  const days = useMemo(() => buildWeekDays(cursor, weekStartsOn), [cursor, weekStartsOn]);
  const eventsByDay = useMemo(() => groupEventsByDay(events), [events]);
  const weekHasEvents = days.some((day) => (eventsByDay.get(day.key)?.length || 0) > 0);

  return (
    <WeekGrid>
      {days.map((day) => {
        const isWeekend = day.date.getDay() === 0 || day.date.getDay() === 6;
        const nomeFeriado = feriadoDe(day.date);
        const ehFeriado = Boolean(nomeFeriado);
        const isToday = isSameDay(day.date, today);
        const list = eventsByDay.get(day.key) || [];

        return (
          <WeekColumn
            key={day.key}
            $weekend={isWeekend || ehFeriado}
            $today={isToday}
            title={ehFeriado ? `Feriado: ${nomeFeriado}` : undefined}
          >
            <WeekColumnHeader>
              <WeekWeekdayLabel>{formatWeekdayShort(day.date)}</WeekWeekdayLabel>
              <DayNumber
                as="button"
                $today={isToday}
                style={{ border: 0, cursor: "pointer", padding: "0 6px" }}
                onClick={() => onJumpToDay?.(day.date)}
                title="Abrir dia"
              >
                {day.date.getDate()}
              </DayNumber>
            </WeekColumnHeader>
            <WeekColumnBody>
              {nomeFeriado && (
                <FeriadoChip title={`Feriado: ${nomeFeriado}`}>
                  <span aria-hidden="true">📅</span> {nomeFeriado}
                </FeriadoChip>
              )}
              {list.length === 0 ? (
                <EmptyMessage style={{ padding: "16px 8px", fontSize: 11 }}>
                  —
                </EmptyMessage>
              ) : (
                <EventosAgrupados eventos={list} onSelectEvent={onSelectEvent} />
              )}
            </WeekColumnBody>
          </WeekColumn>
        );
      })}
      {!weekHasEvents && (
        <EmptyMessage
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          {emptyMessage}
        </EmptyMessage>
      )}
    </WeekGrid>
  );
}
